import { render, staticRenderFns } from "./UploadWorks.vue?vue&type=template&id=af398892&scoped=true"
import script from "./UploadWorks.vue?vue&type=script&lang=js"
export * from "./UploadWorks.vue?vue&type=script&lang=js"
import style0 from "./UploadWorks.vue?vue&type=style&index=0&id=af398892&prod&lang=scss"
import style1 from "./UploadWorks.vue?vue&type=style&index=1&id=af398892&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af398892",
  null
  
)

export default component.exports